var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bar',{'bar__trangle':_vm.type==='trangle'},{'bar__dot':_vm.type==='dot'}],style:(_vm.barStyle)},[(!_vm.$slots.default)?_c('div',{staticClass:"active-shape"}):_c('div',{staticClass:"slot-class"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e07388","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reception/indexPage/TabTrangle.vue
// module id = null
// module chunks = 